import { IUserInfo } from '@/shared/IUserInfo';
import { Box, Tooltip, Tag, TagLabel, TagCloseButton } from '@chakra-ui/react';
import { HStack } from '@chakra-ui/react/stack';
import { AddUserButton } from './AddUserButton'

export const UserListControl = (props: {
  placeholder?: string;
  enableAdd: boolean;

  availableUsers?: IUserInfo[];
  onAddUser: (user: IUserInfo, invite: boolean) => Promise<IUserInfo>;

  users: IUserInfo[];
  onSetUsers: (user: IUserInfo[]) => void;

  title: string;
  description: string;
}) => {

  const onDeleteUser = (user: IUserInfo) => {
    const updatedUsers = props.users.filter(u => u.id !== user.id);
    props.onSetUsers(updatedUsers);
  }

  const onAddUser = async (user: IUserInfo, invite: boolean) => {
    const users = props.users || [];
    const existing = users.find(u => u.id === user.id);
    if (existing) {
      return existing;
    }

    const added = await props.onAddUser(user, invite);
    props.onSetUsers([...users, added]);
  };

  return (
    <HStack justifyItems={'space-between'} alignItems='start' spacing={4}>
      <Box w='full'>
        {props.users?.length ? props.users.map(user => (
          <Tooltip key={user.email} label={user.email} aria-label='User email'>
            <Tag size='md' m={1} colorScheme='brand' key={user.id} borderRadius='full' variant='solid'>
              <TagLabel>{user.name}</TagLabel>
              <TagCloseButton onClick={() => onDeleteUser(user)} />
            </Tag>
          </Tooltip>
        )) : 
        <Box color='gray.500' fontStyle='italic'>{props.placeholder || 'No specific user selected.'}</Box>}
      </Box>
      <AddUserButton
        availableUsers={props.availableUsers || []}
        enableAdd={props.enableAdd}
        onAddUser={onAddUser}
        title={props.title}
        description={props.description}
      />
    </HStack>
  );
}